import axios from "axios";
import store from "../store";
const domain = window.localStorage.getItem("domain");
const port = window.localStorage.getItem("port");
const baseUrl = `${domain}:${port}`;
const request = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json"
  }
});

// FIXME : handle error properly
function errHandler(err) {
  console.error("[error]", err.response.data);
  if (
    err.response.data == "unauthorized" ||
    err.response.data.message.name == "TokenExpiredError"
  )
    store.dispatch("logout");
  throw err.response.data;
}

export { request, errHandler, baseUrl };
